const closeNav = function () {
  const nav = document.querySelector(".site-nav");
  const navLinks = nav.querySelectorAll("a");
  nav.classList.remove("active");
  nav.focus();
  navLinks.forEach((l) => {
    l.tabIndex = -1;
  });
};

const initNav = function () {
  const nav = document.querySelector(".site-nav");
  const openNavButton = document.querySelector(".open-nav");
  const closeNavButton = document.querySelector(".close-nav");
  const navLinks = nav.querySelectorAll("a");
  const contactToggle = nav.querySelector(".toggle-contact-modal a");

  if (contactToggle) {
    const contactModal = document.querySelector(".modal.contact");
    contactToggle.addEventListener("click", () => {
      nav.classList.remove("active");
      document.body.classList.add("modal-active");
      contactModal.classList.add("active");
    });
  }

  navLinks.forEach((l) => {
    l.tabIndex = -1;
  });
  if (openNavButton) {
    openNavButton.addEventListener("click", (e) => {
      e.stopPropagation();
      nav.classList.add("active");
      closeNavButton.focus();
      navLinks.forEach((l) => {
        l.tabIndex = 0;
      });
    });
  }

  closeNavButton.addEventListener("click", () => {
    closeNav(nav);
  });
  const content = document.querySelector(".content-wrapper");
  const header = document.querySelector(".site-header");
  content.addEventListener("click", (e) => {
    closeNav(nav);
  });
  if (header) {
    header.addEventListener("click", (e) => {
      closeNav(nav);
    });
  }
};

export { initNav, closeNav };
